import { gql } from "@apollo/client";
import { skipToken, useSuspenseQuery } from "@apollo/client/react";

import GQLApplication from "./Application.graphql";
import Application, { ApplicationStruct } from "../../features/applications/domain/Application";

export default function useApplication(domain: string) {
    const query = useSuspenseQuery<ApplicationQueryResult>(
        gql(GQLApplication),
        domain
            ? {
                variables: {
                    domain,
                },
            }
            : skipToken,
    );
    return domain
        ? new Application(
            JSON.parse(
                JSON.stringify(query.data.application),
                function (key, value) {
                    if (key === "id") return undefined;
                    if (key === "__typename") return undefined;
                    if (value === null) return undefined;
                    return value;
                },
            )
        )
        : undefined;
}

interface ApplicationQueryResult {
    application: ApplicationStruct
}
